module.exports = __webpack_public_path__ + "static/media/27OCHA5.4c05f8e2.jpg";